import { useState, useCallback } from "react";

const ToggleButtons = ({
  defaultActive = 0,
  variant = "primary",
  buttons = [],
  onClick,
}) => {
  const [active, setActive] = useState(defaultActive);

  const onClickHandler = useCallback(
    (btn, x) => (e) => {
      if (active === x) return;
      setActive(x);
      if (onClick) {
        onClick(e, btn);
      }
    },
    [active, setActive, onClick]
  );

  return (
    <div>
      {buttons?.map((btn, x) => (
        <button
          className={`btn me-3 btn-${
            active === x ? variant : ` text-${variant}`
          }`}
          key={x}
          onClick={onClickHandler(btn, x)}
        >
          <i className={`me-2 bi bi-${btn.icon} fs-16`} />
          {btn.label}
        </button>
      ))}
    </div>
  );
};

ToggleButtons.propTypes = {};

export default ToggleButtons;
